import { optionalEmailAfterTrim } from './optional-email-after-trim.js';
/** API / edit-form: trims, max length, email when present, blanks → null. */
export const optionalTrimmedNullableEmail = (maxLength, invalidMessage) => optionalEmailAfterTrim(maxLength, null, invalidMessage).optional().nullable();
//# sourceMappingURL=optional-trimmed-nullable-email.js.map